import React, { useState, useContext } from "react";
import styled from "styled-components";
import {
    Button,
    LottieLoadingIndicator,
    StandardModal,
    StandardModalActionGroup,
    StandardModalDescription,
    StandardModalFormGroup,
    StandardModalSection,
    StandardModalSectionTitle,
    Toast,
    FormField
} from "src/components";
import axios from "axios";
import { API_URL } from "src/scenes/App";
import { UserContext } from "src/scenes/App/UserContext";

const StyledTitleInput = styled(FormField)`
    border: 1px solid #8291b2;
    border-radius: 12px;
    text-align: left;
    font-family: Manrope, Helvetica, sans-serif;
    font-weight: 400;
    font-size: 1rem;
    color: #000;
    width: 364px;
    max-width: 100%;
    height: 50px;
    box-shadow: none;

    ::placeholder {
        text-align: left;
        color: #808080;
        font-family: Manrope, Helvetica, sans-serif;
    }
`;

const LoadingOverlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;

    display: flex;
    justify-content: center;
    align-items: center;

    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
`;

export default function ChangeMembershipNameDialog(props) {
    const userContext = useContext(UserContext);
    const { hideShowNameChangeDialog, featureName } = props;

    const [isLoading, setIsLoading] = useState(false);
    const [customName, setCustomName] = useState(featureName);

    const onSubmit = async () => {
        setIsLoading(true);
        try {
            await axios.put(`${API_URL}/membershipCard/company/customName`, {
                name: customName
            }, {
                headers: {
                    Authorization: "Bearer " + props.token
                }
            });

            userContext.appFns.updateUserContextProperties({
                customMembershipCardName: customName
            });

            hideShowNameChangeDialog();
        } catch (error) {
            console.log(error);
            Toast.error("Failed to update name");
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <StandardModal
            open={true}
            onClose={hideShowNameChangeDialog}
            title="Change Digital Member Card Feature Name"
            description="Rename the Digital Member Card feature in the Me Business app and portal to better match your business or community."
            widthMode="medium"
            footer={(
                <StandardModalActionGroup $pushRight>
                    <Button
                        type="button"
                        onClick={() => hideShowNameChangeDialog()}
                        size="0.875rem"
                        border="1px solid #000"
                        color="#000"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="submit"
                        backgroundColor="#171A22"
                        border="1px solid #171A22"
                        color="#fff"
                        width="8.75rem"
                        style={{ borderRadius: "7px", boxShadow: "none" }}
                        onClick={() => onSubmit()}
                    >
                        Save
                    </Button>
                </StandardModalActionGroup>
            )}
        >
            {isLoading && (
                <LoadingOverlay>
                    <LottieLoadingIndicator />
                </LoadingOverlay>
            )}
            <StandardModalSection>
                <StandardModalFormGroup>
                    <StandardModalSectionTitle>Set a Custom Name (Optional)</StandardModalSectionTitle>
                    <StandardModalDescription>
                        Enter a new name for this feature. If left blank, it will continue to appear as ‘Digital Member Card’.
                    </StandardModalDescription>
                    <StyledTitleInput
                        name="CustomSalesPromotionsName"
                        value={customName}
                        placeholder="e.g. Daily Inspiration"
                        onChange={(e) => setCustomName(e.target.value || "")}
                    />
                </StandardModalFormGroup>
            </StandardModalSection>
        </StandardModal>
    );
}
